import React from 'react';
import { LottieWrapper } from '../../../fibe-ui';

import SuccessLottieJSON from '../../lottie-json/auto-debit/fibo-with-pom-pom.json';

const ThankYouBodyContent = ({ title, subtitle }) => {
  return (
    <div className="w-full h-full max-h-[85vh]">
      <div className="m-[10%] flex flex-col justify-center items-center bg-[#E6F5F5] rounded-2xl text-center">
        <div className="flex flex-col rounded-xl">
          <div className="m-auto">
            <LottieWrapper
              animationData={SuccessLottieJSON}
              width="150px"
              height="150px"
            />
          </div>
          <span className="mt-5 font-headline font-bold text-[28px] text-center max-w-[80%] mx-auto">
            {title}
          </span>
          <span
            className="font-headline mt-3 mb-2 font-semibold text-base text-text-secondary text-center max-w-[80%]  mx-auto"
            dangerouslySetInnerHTML={{ __html: `${subtitle}` }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default ThankYouBodyContent;
